import { takeEvery } from 'redux-saga/effects';
import { MULTI_ACT_CREATE_ACTS } from '../constants';
import createActsFromNamsProcess from './createActsFromNamsProcess';

export default function* multiActCreateActsFromNamsSagas() {
  yield takeEvery(MULTI_ACT_CREATE_ACTS, createActsFromNamsProcess);
}
